// Drapeaux dessinés, pas des emoji.
//
// Les emoji de drapeau (🇫🇷, 🇬🇧) n'ont aucun glyphe sur la plupart des systèmes Linux et
// Windows : le navigateur y affiche alors les deux lettres du code pays, ou un carré vide.
// Deux SVG de quelques lignes suffisent et s'affichent partout à l'identique.

const RADIUS = 2;

/** Drapeau français — trois bandes verticales. */
function FR() {
  return (
    <>
      <rect width="16" height="12" rx={RADIUS} fill="#ED2939" />
      <path d="M0 0h10.67v12H0z" fill="#fff" />
      <path d="M0 0h5.33v12H0z" fill="#002395" />
    </>
  );
}

/** Drapeau britannique — croix de Saint-André puis croix de Saint-Georges par-dessus. */
function GB() {
  return (
    <>
      <rect width="16" height="12" rx={RADIUS} fill="#012169" />
      {/* Diagonales blanches, puis leurs liserés rouges. */}
      <path d="M0 0l16 12M16 0L0 12" stroke="#fff" strokeWidth="2.6" />
      <path d="M0 0l16 12M16 0L0 12" stroke="#C8102E" strokeWidth="1.2" />
      {/* Croix droite : blanche dessous, rouge dessus. */}
      <path d="M8 0v12M0 6h16" stroke="#fff" strokeWidth="4" />
      <path d="M8 0v12M0 6h16" stroke="#C8102E" strokeWidth="2.4" />
    </>
  );
}

const FLAGS = { fr: FR, en: GB } as const;

export function Flag({ code }: { code: keyof typeof FLAGS }) {
  const Shape = FLAGS[code];

  return (
    <svg
      viewBox="0 0 16 12"
      width={20}
      height={15}
      aria-hidden
      // La découpe empêche les diagonales du drapeau britannique de dépasser des coins.
      className="shrink-0 rounded-[2px] ring-1 ring-inset ring-black/10"
      style={{ clipPath: `inset(0 round ${RADIUS}px)` }}
    >
      <Shape />
    </svg>
  );
}
